var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgScrollTriangles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 30,
    viewBox: "0 0 51 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5974 27.9964L11.542 2.20289C10.8925 1.27501 11.5563 4.77517e-05 12.6889 4.78013e-05L48.1444 4.93511e-05C49.277 4.94006e-05 49.9409 1.27501 49.2913 2.2029L31.2359 27.9964C30.8378 28.5651 29.9955 28.5651 29.5974 27.9964Z",
    fill: "#FE004E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5974 27.9963L1.54199 2.20283C0.892472 1.27495 1.55629 -1.32834e-05 2.68892 -1.32339e-05L38.1444 -1.16841e-05C39.277 -1.16346e-05 39.9409 1.27495 39.2913 2.20284L21.2359 27.9963C20.8378 28.565 19.9955 28.565 19.5974 27.9963Z",
    fill: "#00F6EF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScrollTriangles);
export default __webpack_public_path__ + "static/media/ScrollTriangles.c0391d761dd90689de6df21824d9e020.svg";
export { ForwardRef as ReactComponent };